import styled from 'styled-components';

import { getVariant } from '@/themes/typographyUtilis';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0;
  border: 1px solid ${({ theme }) => theme.colors.background.extraLight};
  border-radius: 8px;
  padding: 14px 18px;
  background: ${({ theme }) => theme.colors.background.light};
  gap: 8px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 12px;
`;

export const TitleGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const TitleDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.teal};
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.primaryText};
  ${getVariant({ variant: 'body2-bold' })}
`;

export const AnalysisUsageText = styled.span`
  color: ${({ theme }) => theme.colors.secondaryText};
  ${getVariant({ variant: 'body2-normal' })}

  strong {
    color: ${({ theme }) => theme.colors.primaryText};
    font-weight: 600;
  }
`;

export const Label = styled.span`
  color: ${({ theme }) => theme.colors.secondaryText};
  ${getVariant({ variant: 'body2-normal' })}
`;

export const PercentageText = styled.span`
  color: ${({ theme }) => theme.colors.teal};
  ${getVariant({ variant: 'body2-bold' })}
`;

export const FooterText = styled.span`
  color: ${({ theme }) => theme.colors.secondaryText};
  ${getVariant({ variant: 'body2-normal' })}
`;
